import { EventsService } from "@app/services/events.service"
import { ActivatedRoute, Router, RouterLink } from "@angular/router"
import {
	Component,
	Input,
	OnInit,
	ChangeDetectionStrategy,
} from "@angular/core"
import { ConfigDefinitions } from "@app/definitions/types"
import { ValidatorService } from "@app/services/validator.service"
import { LangService } from "@app/services/lang.service"

import { ApiService } from "@app/services/api.service"
import { Configcliniq } from "@app/definitions/types"
import { PermsService } from "@app/services/perms.service"
import { StoreService } from "@app/services/store.service"
import { COMMON_IMPORTS } from "../common-imports"
import { LangValPipe } from "@app/utils/lang-val.pipe"
import {
	GenTable2Component,
	GenTableComponent,
} from "@app/gen-table/gen-table.component"
import { PolicyFormsMenuComponent } from "@app/policy-forms-menu/policy-forms-menu.component"
import { CcParamsJournalComponent } from "@app/cc-params-journal/cc-params-journal.component"
import { CcParamsUserDetailsComponent } from "@app/cc-params-user-details/cc-params-user-details.component"
import { CcParamsTaxesComponent } from "@app/cc-params-taxes/cc-params-taxes.component"
import { CcParamsHolidayComponent } from "@app/cc-params-holiday/cc-params-holiday.component"
import { CcParamsSwitchComponent } from "@app/cc-params-switch/cc-params-switch.component"
import { CcParamsSecurityComponent } from "@app/cc-params-security/cc-params-security.component"
import { CcParamsSelfCoordinationComponent } from "@app/cc-params-self-coordination/cc-params-self-coordination.component"
import { CcParamsAutomationComponent } from "@app/cc-params-automation/cc-params-automation.component"
import { CcSectionsComponent } from "@app/cc-sections/cc-sections.component"

@Component({
	selector: "app-config-cliniq",
	imports: [
		COMMON_IMPORTS,
		RouterLink,
		LangValPipe,
		GenTableComponent,
		GenTable2Component,
		PolicyFormsMenuComponent,
		CcParamsJournalComponent,
		CcParamsUserDetailsComponent,
		CcParamsTaxesComponent,
		CcParamsHolidayComponent,
		CcParamsSwitchComponent,
		CcParamsSecurityComponent,
		CcParamsSelfCoordinationComponent,
		CcParamsAutomationComponent,
		CcSectionsComponent,
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: "./config-cliniq.component.html",
})
export class ConfigCliniqComponent implements OnInit {
	@Input() innerSectionName: string = "" //current inner section
	configcliniq: Configcliniq //the config object from the DB
	showMenu: boolean = false //show the menu or hide (relevant only in mobile display)

	sideItems: any[] = [
		//each item has a sectionName that can also be used by the url, icon, lang for display
		{ sectionName: "user_area", icon: "sub_user", lang: "userdetails" },

		//	{ sectionName: "user", icon: "sub_user", lang: "userdetails" },
		{ sectionName: "journal", icon: "calendar", lang: "calendar_config" },
		{ sectionName: "patients", icon: "patient" },
		{ sectionName: "payors", icon: "payor" },
		{ sectionName: "contacts", icon: "contact" },
		{ sectionName: "headtures", icon: "header" },
		/*{ sectionName: "holiday", icon: "holiday", lang: "holidays" },*/
		/*{ sectionName: "patienttypes", icon: "patienttype",  },*/
		{ sectionName: "taxes", icon: "tax", lang: "financial" },
		{ sectionName: "tests", icon: "documenttemplate" },
		// { sectionName: "zones", icon: "list1", },
		{ sectionName: "user_payments", icon: "payment" },
		{ sectionName: "info_tables", icon: "info" },
		{ sectionName: "switches", icon: "sliders", lang: "preferences" },
		{ sectionName: "security", icon: "security" },
		{
			sectionName: "self_coordination",
			icon: "calendar-check",
		},
		{ sectionName: "automation", icon: "automation" },
		{ sectionName: "products", icon: "header" },
		{ sectionName: "policy_forms", icon: "header" },
		/*{ sectionName: "payors", icon: "payor",  },*/
		/*{ sectionName: "ownerbankaccounts", icon: "bankaccount", lang: "bankaccounts" },*/
		/*{ sectionName: "accountant", icon: "accountant",  },*/
		/* { sectionName: "hashav", icon: "hashav",  },*/
	]

	constructor(
		private apiService: ApiService,
		public lang: LangService,
		public validator: ValidatorService,
		private route: ActivatedRoute,
		public eventsService: EventsService,
		public permsService: PermsService,
		public router: Router,
		private store: StoreService
	) {
		this.configcliniq = this.store.cc()
	}

	async ngOnInit() {
		this.showMenu = !this.eventsService.isMobile //reset to false if mobile

		this.route.queryParams.subscribe((params) => {
			if (params["showMenu"]) {
				if (this.eventsService.isMobile) {
					this.showMenu = true
				}
			}
		})

		if (!this.innerSectionName) {
			this.innerSectionName = this.permsService.owner_has_users
				? "multiuser"
				: "user_area"
		}

		if (!this.permsService?.perms?.administrative) {
			this.router.navigateByUrl("/", { replaceUrl: true })
		}

		if (
			this.permsService.owner_has_users &&
			!this.sideItems.find((it) => it.sectionName == "multiuser")
		) {
			this.sideItems.unshift({
				sectionName: "multiuser",
				icon: "users",
				lang: "multiuser",
			})
		}
		const cc = this.store.cc()

		if (this.permsService.owner_has_users) {
			this.sideItemRemove("user_area")
		}
		if (["free", "intern"].includes(cc.status)) {
			this.sideItemRemove("user_payments")
		}

		if (
			cc?.meeting_request_pay !== "yes" &&
			this.sideItems.find((it) => it.sectionName == "products")
		) {
			this.sideItemRemove("products")
		}
		if (
			cc?.enable_policy_forms !== "yes" &&
			this.sideItems.find((it) => it.sectionName == "policy_forms")
		) {
			this.sideItemRemove("policy_forms")
		}

		this.eventsService.isMobileSubj.subscribe(() => {
			//when isMobile changes, make sure to reset again (mobile is false)
			this.showMenu = !this.eventsService.isMobile
		})
	}
	sideItemRemove(name: string) {
		this.sideItems = this.sideItems.filter((it) => it.sectionName !== name)
	}

	sideMenuClick() {
		//on clicking any side menu item, if mobile - closes the menu
		window.scroll(0, 0)
		if (this.eventsService.isMobile) {
			this.showMenu = false
		}
	}
}
